/* globals $, google */
Promise.all([
  $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCQX5RfPyvpssFnBF9TiJMLkd0Pn-XspnU&libraries=places'),
]).then(() => {
  setup();
  document.addEventListener("remount:stationfinder", remount);
});

function setup() {
  // Ajax Submit and Load
  $(document).on('submit', '.stationfinder-form', function(e) {
      e.preventDefault();
      $('.stationfinder-submit').addClass('disabled');
      $('.station_results_container').html('<div class="spinner"></div>');
      var address = $("#formatted-address").val()
      $.ajax({
          url: $(this).attr('action'),
          type: "GET",
          data: $(this).serialize() + '&isjs=true',
          success: function(results) {
              $('.main-content-wrapper').html(results);
              initFinderPlaces(address);
          },
          error: function() {
              $('.station_results_container').html('<span class="error">There was an error finding results. Please try again.</span>');
          }
      });
  });

  // Update form on International
  $(document).on('click', '#stationfinder-international', function(e) {
      e.preventDefault();
      toggleStationFinderForm();
      $('#stationfinder-country-form').submit();
  });

  // Submit on country change.
  $(document).on('change', '#stationfinder-country-country', function() {
      $(this).closest('form').submit();
  });
  $(document).on('change', '#stationfinder-google-places', function() {
      if ($(this).val().length > 4) {
          $(this).closest('form').submit();
      }
  });

  remount();
}


function remount() {
  $('.main-content-support').addClass('js');
  initFinderPlaces();

    // Get Current Position
  if (!$('.input[name=zip]').val() && (!$('#stationfinder-zip-country').val() || $('#stationfinder-zip-country').val() == 'US') && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(autoSetFinderZip);
  }
}

function initFinderPlaces(formatted_address) {
  var country_field = $("#stationfinder-zip-country");
  var countries = ['US', 'CA'];
  var country_val = country_field.val();
  var pac_input = $("#pac-input");
  pac_input.val(formatted_address);

  if (countries.indexOf(country_val) != -1) {
    var input = document.getElementById('pac-input');
    selectFirstOnEnter(input);
    var options = {
      componentRestrictions: {country: country_val.toLowerCase()}
    };
    // Supplied by maps.googleapis.com in initializeStationFinderPage
    var searchBox = new google.maps.places.Autocomplete(input, options);

    searchBox.addListener('place_changed', function () {
      var found_zip = false;
      var place = searchBox.getPlace();
      var message = "<p>Please be sure to enter an address or zip/postal code more specific than <b>XXXXXXXX</b>.</p>";

      if (place.length == 0 || place.address_components === undefined) {
        message = message.replace("XXXXXXXX", pac_input.val());
        $('.station_results_container').html(message);
        return;
      }

      place.address_components.forEach(function (component) {
        component.types.forEach(function (type) {
          if (type == "postal_code") {
            found_zip = true;
            $("#stationfinder-google-places").val(component.long_name);
            $("#formatted-address").val(place.formatted_address);
            $("#stationfinder-zip-form").submit();
          }
        });
      });

      if (found_zip === false) {
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        if (latitude != Math.floor(latitude) && longitude != Math.floor(longitude)) {
          var position = { "coords": { "latitude": latitude, "longitude": longitude } };
          autoSetFinderZip(position, false, country_val);
          $("#formatted-address").val(place.formatted_address);
        }
        else {
          message = message.replace("XXXXXXXX", pac_input.val());
          $('.station_results_container').html(message);
        }
      }
      return;
    });
  }
}

// Helpers
function toggleStationFinderForm() {
    $('#stationfinder-input-country').toggleClass('hidden');
    $('#stationfinder-input-zip').toggleClass('hidden');
    $('input[name=zip]').val("");
    $('#stationfinder-country-country').each( function() {
        $(this).removeAttr('selected');
    });
    var first_opt = $("#stationfinder-country-country option:first");
    first_opt.attr('selected','selected');
    $('#stationfinder-country-country').val(first_opt.val());
    $('.station_results_container').text(' ');
    var address = $("#formatted-address").val();
    initFinderPlaces(address);
}


function autoSetFinderZip(position, show_text=true, country_val="") {
    var latitude = position.coords.latitude;
    var longitude = position.coords.longitude;
    var url = 'https://secure.geonames.org/findNearbyPostalCodesJSON?maxRows=1&country=' + country_val + '&lat=' + latitude + '&lng=' +  longitude + '&username=tflapi';
    $.ajaxSetup({
        timeout: 15000 // Time in milliseconds
    });
    // Disable search input field, for clicking in it
    // will short circuit getJSON():
    $("#pac-input").prop('disabled', true);
    if (show_text === true) {
      $('#stationfinder-message').text('Determining location...');
    }
    $.getJSON(url, function(data) {
        if (data.postalCodes && data.postalCodes.length > 0 && data.postalCodes[0].postalCode && !$('input[name=zip]').val() && !$('.stationfinder-input').is(":focus")) {
            $('input[name=zip]').val(data.postalCodes[0].postalCode);
            $('input[name=zip]').closest('form').submit();
        }
        $('#stationfinder-message').text('');
    })
    .always(function() {
      $("#pac-input").prop('disabled', false);
      var address = $("#formatted-address").val();
      initFinderPlaces(address);
    });
}

// https://stackoverflow.com/questions/14601655/google-places-autocomplete-pick-first-result-on-enter-key
function selectFirstOnEnter(input){
  // store the original event binding function
  var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

  // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
  // and then trigger the original listener.
  function addEventListenerWrapper(type, listener) {
    if (type == "keydown") {
      var orig_listener = listener;
      listener = function (event) {
      var suggestion_selected = $(".pac-item-selected").length > 0;
        if (event.which == 13 && !suggestion_selected) {
          var simulated_downarrow = $.Event("keydown", { keyCode:40, which:40 });
          orig_listener.apply(input, [simulated_downarrow]);
        }
        orig_listener.apply(input, [event]);
      };
    }
    // add the modified listener
    _addEventListener.apply(input, [type, listener]);
  }
  if (input.addEventListener) {
    input.addEventListener = addEventListenerWrapper;
  } else if (input.attachEvent) {
    input.attachEvent = addEventListenerWrapper;
  }
}
